import { string } from 'prop-types';

const searchResultPropTypes = {
  text: string.isRequired,
};

export { searchResultPropTypes };
